import {Box, Typography} from '@mui/material';
import AurButton from '../../../../common/aur-button/AurButton';
import {t} from 'i18next';
import {useFileCatalystDownload} from '../../../../../hooks/upload-evidence-source/useFileCatalystDownload';
import AurLoadingIndicator from '../../../../common/aur-loading-indicator/AurLoadingIndictor';
import {ReactComponent as ResetIcon} from '../../../../../assests/svg/reset.svg';
import {ReactComponent as DownloadIcon} from '../../../../../assests/svg/download_blue_icon.svg';

interface FCRetryConnectionViewProps {
  isVisibleFromFCDownloadScreen?: boolean;
  descMessage?: string;
  onRetry?: () => void;
}

const FCRetryConnectionView: React.FC<FCRetryConnectionViewProps> = ({
  isVisibleFromFCDownloadScreen = false,
  descMessage = '',
  onRetry,
}: FCRetryConnectionViewProps) => {
  const {downloadFileCatalyst, isDownloading, progress} =
    useFileCatalystDownload();

  return (
    <Box
      className={`fc-retry-connection-container ${isVisibleFromFCDownloadScreen ? 'fc-retry-connection-container-height' : ''}`}
    >
      <Typography
        className="typo-text body2_size subtitle-text-color"
        tabIndex={0}
      >
        {descMessage}
      </Typography>
      <Box className={'fc-button-container'}>
        <AurButton
          classNames={'fc-retry-button'}
          type={'continue'}
          label={t('fileCatalyst.retry')}
          title={t('fileCatalyst.retry')}
          ariaDescription={t('fileCatalyst.retry')}
          size={'Large'}
          onClick={onRetry}
          endIcon={<ResetIcon aria-hidden="true" />}
        />
        <Box className={'fc-download-button-container'}>
          <AurButton
            type={'secondary'}
            label={t('fileCatalyst.download')}
            title={t('fileCatalyst.download')}
            ariaDescription={t('fileCatalyst.download')}
            size={'Large'}
            onClick={downloadFileCatalyst}
            endIcon={
              isDownloading ? (
                <AurLoadingIndicator size={20} className="button-loader" />
              ) : (
                <DownloadIcon aria-hidden="true" />
              )
            }
          />
          {isDownloading && progress > 0 ? (
            <Typography
              className="typo-text subhead4_size downloading-label"
              tabIndex={0}
            >{`${t('fileCatalyst.downloading')} ${progress}%`}</Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default FCRetryConnectionView;
